import { useEffect, useRef } from 'react';
import heroImg from '../../assets/images/saladin_hero.png';
import './Collage.css';

const Collage = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.querySelectorAll('.collage__layer')
                            .forEach((el, i) => {
                                setTimeout(() => el.classList.add('revealed'), i * 80);
                            });
                    }
                });
            },
            { threshold: 0.1 }
        );
        if (sectionRef.current) observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section id="collage" className="collage-section" ref={sectionRef}>
            <div className="section-wrapper">
                <div className="collage-section__header reveal">
                    <span className="section-tag">Historical Digital Collage</span>
                    <h2 className="section-title">
                        A <span className="gold-text">Legacy</span> Sculpted in Time
                    </h2>
                    <div className="divider"></div>
                    <p className="collage-section__desc">
                        A layered exploration of the sultan's world — the architecture, the faith, and the chivalry that defined an era.
                    </p>
                </div>

                <div className="collage-section__canvas">
                    <div className="collage__layer collage__layer--bg"></div>
                    <div className="collage__layer collage__layer--noise"></div>
                    <div className="collage__layer collage__layer--pattern-bg"></div>

                    <div className="collage__layer collage__layer--arch-left"></div>
                    <div className="collage__layer collage__layer--arch-right"></div>

                    <div className="collage__layer collage__layer--geo-burst"></div>

                    <div className="collage__layer collage__layer--map-large"></div>

                    <div className="collage__layer collage__layer--portrait-container">
                        <div className="collage__portrait-frame">
                            <img src={heroImg} alt="Saladin artistic portrait" className="collage__portrait-img-v2" />
                            <div className="collage__portrait-overlay"></div>
                        </div>
                    </div>

                    <div className="collage__layer collage__layer--parchment-roll">
                        <div className="collage__parchment-content">
                            <h4>AL-NASIR SALAH AL-DIN</h4>
                            <p>Yusuf ibn Ayyub</p>
                            <small>Sultan of Egypt and Syria</small>
                            <div className="collage__wax-seal"></div>
                        </div>
                    </div>

                    <div className="collage__layer collage__layer--scimitar">
                        <div className="collage__scimitar-blade"></div>
                        <div className="collage__scimitar-hilt"></div>
                    </div>

                    <div className="collage__layer collage__layer--jerusalem-alt">
                        <div className="collage__dome-silhouette"></div>
                    </div>

                    <div className="collage__layer collage__layer--script-arabic"></div>
                    <div className="collage__layer collage__layer--script-latin"></div>

                    <div className="collage__layer collage__layer--calligraphy-large">
                        <span>صلاح الدين</span>
                    </div>

                    <div className="collage__layer collage__layer--star-gold"></div>
                    <div className="collage__layer collage__layer--star-crimson"></div>

                    <div className="collage__layer collage__layer--ink-blot-1"></div>
                    <div className="collage__layer collage__layer--ink-blot-2"></div>
                    <div className="collage__layer collage__layer--gold-dust"></div>

                    <div className="collage__layer collage__layer--vignette"></div>
                    <div className="collage__layer collage__layer--border-inner"></div>
                </div>
            </div>
        </section>
    );
};

export default Collage;
